export class AppSettings {
  // 定義 cache key
  public static CACHE_KEY_HOSPITAL_LIST = 'hospital_list';
  public static CACHE_KEY_EXPERT_LIST = 'expert_list';
  public static CACHE_KEY_POST_LIST = 'post_list';
  public static CACHE_KEY_VOTE_LIST = 'vote_list';
  public static CACHE_KEY_PGC_POST_SCORE_LIST = 'pgc_post_score_list';
  public static CACHE_KEY_MAK_DEVICE_LIST = 'mak_device_list';
  public static CACHE_KEY_MAK_MP3_LIST = 'mak_mp3_list';
  public static HospitalBadgeDict: any = {
    全馨護推薦: 'assets/img/Badge01.png',
    全馨護特約藥局: 'assets/img/Badge04.png',
    人氣王: 'assets/img/Badge02.png',
    高CP值: 'assets/img/Badge06.png',
    頂級奢華: 'assets/img/Badge05.png',
  };
  public static AUTO_REPLY_DISPLAY_NAME = '智慧助理';
  public static APP_NAME = '全馨護';
  public static APP_CODE = 'patient';
  public static APP_VERSION_CODE = '3.0.24';
  public static DISABLE_AD = true; // 是否關閉廣告
  public static POSTS_PER_PAGE = 20; // 育兒知識 呼叫 wp-api 每頁撈取的筆數

  public static SEO_DEFAULT_TITLE = '全馨護-匯聚照護力量，值得信賴的健康平台';
  public static SEO_DEFAULT_DESCRIPTION =
    '我們致力於提供有邏輯的解決方案給正處於慢性疾病的個案，我們團隊由醫師藥師護理師營養師組成，以專業為出發點，打造一站式服務健康關懷平台，讓大家全馨護!';
  public static SEO_DEFAULT_SUFFIX = '|全馨護';
  public static SEO_SITE_NAME = '全馨護'; //og:site_name
  public static SEO_DEFAULT_OG_IMAGE = '/assets/img3/og_default.png'; // 相對路徑，會在使用時轉換為絕對路徑

  // APP 商店下載連結（web 版引導使用者下載 native app 用）
  public static URL_APP_STORE =
    'https://apps.apple.com/us/app/%E5%85%A8%E9%A6%A8%E8%AD%B7/id6768308992';
  public static URL_GOOGLE_PLAY =
    'https://play.google.com/store/apps/details?id=tw.com.omnihealth.app';

  public static URL_ABOUT = 'https://www.omnihealth.com.tw/omni_about/';

  // 聯絡我們
  public static URL_CONTACT = 'https://www.omnihealth.com.tw/omni_contact/#contact';

  // 意見回饋
  public static URL_FEEDBACK = 'https://forms.gle/9ZZNQTC8EYbw2rbi6';

  // 隱私權政策
  public static URL_PRIVACY = 'https://www.omnihealth.com.tw/omni-privacy-policy.html';

  // 服務條款
  public static URL_TERMS = 'https://www.omnihealth.com.tw/omni-terms-of-service.html';

  // 電子商務約定條款
  public static URL_EC_TERMS =
    'https://appinfo.omnihealth.com.tw/mcuapp/ecservice.html';

  // 關於退貨退款
  public static URL_EC_RETURN_TERMS =
    'https://appinfo.omnihealth.com.tw/mcuapp/ecservice.html#return';

  // ISR cache 的時效, 區分高、中、低
  // 內容相關的 cache, 以及不會變動的 cache, 可以設定較長的時效 (ex: 文章, 藥局, 專家)
  // EC 相關的 cache, 以及會變動的 cache, 設定較短的時效 (ex: 訂單, 購物車)
  // 行為相關的 cache, 設定 中 的時效 (ex: 登入, 註冊..)
  public static ISR_CACHE_EXPIRE_HIGH = 600; // 600秒
  public static ISR_CACHE_EXPIRE_MEDIUM = 60; // 60秒
  public static ISR_CACHE_EXPIRE_LOW = 10; // 10秒

  // 刪除帳號的表單 (for android google play 設定使用)
  public static URL_DELETE_ACCOUNT_FORM =
    'https://appinfo.omnihealth.com.tw/app/prod/delete_account_form.html';

  // 百寶袋說明
  public static URL_GROUPBUY_INFO =
    'https://appinfo.omnihealth.com.tw/app/prod/groupbuy_info.html';

  // ========== MAK 健康趨勢分析門檻 ==========
  // 注意門檻：正常率下降超過此百分比顯示黃色提示
  public static MAK_TREND_CAUTION_THRESHOLD = 10;
  // 警告門檻：正常率下降超過此百分比顯示橙色警示
  public static MAK_TREND_WARNING_THRESHOLD = 20;
  // 危險正常率：近期正常率低於此百分比顯示紅色警示
  public static MAK_TREND_DANGER_RATE = 50;
  // 連續異常筆數門檻：連續異常廔音達此筆數顯示紅色警示
  public static MAK_CONSECUTIVE_ABNORMAL_THRESHOLD = 3;
}
